/** Formats a date as "May 22, 2026 3:03pm" for entry-instructions timestamps. */
export function formatEntryInstructionsLastUpdated(value) {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;

  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];
  const hours24 = d.getHours();
  const minutes = d.getMinutes();
  const ampm = hours24 >= 12 ? 'pm' : 'am';
  const hours12 = hours24 % 12 || 12;
  const minuteStr = minutes < 10 ? `0${minutes}` : String(minutes);

  return `${monthNames[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()} ${hours12}:${minuteStr}${ampm}`;
}

/** Prefer order.entryInstructionsLastUpdated, then newest order/property history entry. */
export function resolveEntryInstructionsLastUpdated(order) {
  if (order?.entryInstructionsLastUpdated) {
    return order.entryInstructionsLastUpdated;
  }

  const historySources = [
  ...(Array.isArray(order?.entryInstructionsHistory) ? order.entryInstructionsHistory : []),
  ...(Array.isArray(order?.property?.entryInstructionsHistory) ? order.property.entryInstructionsHistory : []),
  ];

  if (historySources.length === 0) return null;

  const latest = historySources.reduce((best, entry) => {
    if (!entry?.updatedAt) return best;
    if (!best?.updatedAt) return entry;
    return new Date(entry.updatedAt) > new Date(best.updatedAt) ? entry : best;
  }, null);

  return latest?.updatedAt || null;
}

/** Formats an ISO-8601 string into 
 *  “Month DaySuffix, Year HH:MM AM/PM” */
 export function formatDate(isoString) {
    if (!isoString) return '—';
    const [datePart, timePart] = isoString.split('T');
    const [year, month, day] = datePart.split('-');
    const [hourRaw, minuteRaw] = timePart.split(':');
    const h = parseInt(hourRaw, 10), m = minuteRaw;
    const hour12 = h % 12 || 12;
    const ampm = h >= 12 ? 'PM' : 'AM';
    const suffix =
      ['11','12','13'].includes(day) ? 'th'
      : day.endsWith('1')               ? 'st'
      : day.endsWith('2')               ? 'nd'
      : day.endsWith('3')               ? 'rd'
      : 'th';
    const names = [
      'January','February','March','April','May','June',
      'July','August','September','October','November','December'
    ];
    return `${names[parseInt(month,10) - 1]} ${parseInt(day,10)}${suffix}, ${year} ` +
           `${hour12}:${m} ${ampm}`;
  }
  